import { request } from './client';

export type ReferencePostStyle =
  | 'ALL'
  | 'AGGRO'
  | 'INFO'
  | 'STORY'
  | 'LIST'
  | 'QUESTION';

export const REFERENCE_POST_STYLES: {
  value: ReferencePostStyle;
  label: string;
  help: string;
}[] = [
  { value: 'ALL', label: '전체', help: '형태 제한 없음' },
  { value: 'AGGRO', label: '어그로', help: '후킹·자극형' },
  { value: 'INFO', label: '정보성', help: '팁·정리·가이드' },
  { value: 'STORY', label: '경험담', help: '사연·후기형' },
  { value: 'LIST', label: '리스트', help: '넘버링·체크리스트' },
  { value: 'QUESTION', label: '질문유도', help: '댓글·공감 유도' },
];

export interface ThreadReferencePost {
  threadMediaId?: string;
  text: string;
  username?: string;
  permalink?: string;
  timestamp?: string;
  views?: number;
  likes?: number;
  replies?: number;
  popularityRank?: number;
  source?: 'threads' | 'tavily' | string;
  style?: ReferencePostStyle;
  styleLabel?: string;
}

export interface ThreadReferenceSearchResult {
  keyword: string;
  expandedKeywords?: string[];
  style?: ReferencePostStyle;
  styleLabel?: string;
  minViews?: number;
  warning?: string | null;
  posts: ThreadReferencePost[];
}

export function searchReferences(
  threadAccountId: number,
  keyword: string,
  limit = 15,
  style: ReferencePostStyle = 'ALL'
) {
  const params = new URLSearchParams({
    q: keyword,
    limit: String(limit),
    style,
  });
  return request<ThreadReferenceSearchResult>(
    `/api/thread-accounts/id/${threadAccountId}/reference-search?${params}`,
    { method: 'GET' }
  );
}
